import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { IServer } from '@cbridge-packages/server';
import { nodeStoreSelector } from '../node.selector';

export const nodeIdByServerIdSelector = createCachedSelector(
  [
    path(nodeStoreSelector).list(),
    prop<{ serverId: IServer['serverId'] }>().serverId(),
  ],
  (nodeList, serverId) => {
    for (const node of nodeList) {
      if (node.servers) {
        const server = node.servers.find(server => server.value === serverId);
        if (server) {
          return node.nodeId;
        }
      }
    }
    return undefined;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ serverId: IServer['serverId'] }>().serverId(),
});
